import { LightTooltip } from '../min-sidebar-community-list/MinSidebarCommunityList';
import React from 'react';

import CoCoTeamIcon from '!!react-svg-loader!./icons/icon--cocoteam.svg';
import { Jam } from '../../atoms/jams';
import { TooltipProps } from '@mui/material/Tooltip';
import { Without } from '../modal-dialog/CloseableDialog';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useParams } from 'react-router-dom';

export default function CountryOrCocoTag(p: {
  jam: Jam;
  tooltipProps?: Without<TooltipProps, 'title' | 'children'>;
}) {
  const { _ } = useLingui();

  const { handle } = useParams<{ handle?: string }>();

  return (
    <LightTooltip
      placement={'bottom'}
      arrow
      {...p.tooltipProps}
      title={`${p.jam.country ? p.jam.country.toUpperCase() : _(msg`CoCo Team`)}`}
    >
      <span style={{ display: handle ? 'none' : 'flex', alignItems: 'center' }}>
        {p.jam.country ? (
          <img
            src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${p.jam.country?.toUpperCase()}.svg`}
            alt={`${p.jam.country?.toUpperCase()} flag`}
            style={{
              width: 20,
              height: 16,
            }}
          />
        ) : (
          <CoCoTeamIcon width={20} height={16} />
        )}
      </span>
    </LightTooltip>
  );
}
